import { ReactNode } from "react";
import { useBreadcrumbs, type BreadcrumbSegment } from "@/contexts/breadcrumb-context";

interface PageHeaderProps {
  breadcrumb?: BreadcrumbSegment[];
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  hideBreadcrumbOnMobile?: boolean;
}

export function PageHeader({ breadcrumb, title, description, actions }: PageHeaderProps) {
  const hasBreadcrumb = !!breadcrumb;
  useBreadcrumbs(hasBreadcrumb ? breadcrumb : undefined);

  return (
    <header className="flex flex-col gap-3 mb-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {description && (
            <p className="text-sm text-muted-foreground" data-testid="text-page-description">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </header>
  );
}
